<template lang="pug">
  div
    notifications(group="finance" position="top center")
    b-row.justify-content-md-center
      ReloadAppDialog(:showDialog="showDialog")
      b-col(md="12")
        b-row
          b-col.download-btns(md="7")
            b-button.btn-space(@click="exportAll", variant="primary" size="sm")
              icon(name="download")
              |  Todos
            b-button.btn-space(@click="openModal('discount')", variant="secondary" size="sm")
              icon(name="download")
              |  Descuentos
            b-button.btn-space(@click="paypalModal", variant="primary" size="sm")
              icon(name="paypal")
              |  PayPal
            b-button.btn-space(@click="openModal('bice')", variant="success" size="sm")
              icon(name="download")
              |  Exportar Bice
            b-button.btn-space(@click="importBice", variant="warning" size="sm")
              icon(name="upload")
              |  Importar Bice
            b-button(variant="primary" ,:pressed.sync="resolved" ,@click="showResolved($event)", size="sm" right) Resueltos
              span(v-if="resolved") &nbsp;&nbsp;
              icon(name="check" v-if="resolved")
            input#requestFile(type="file" ,@change="uploadFile()" hidden)
          b-col(md="5")
            b-input-group
              b-form-input(v-model="filterText", @keyup.enter.native="search")
              b-input-group-button(slot='right')
                b-btn(@click="search")
                  icon(name="search")

        b-table(hover :fields="complaintFields" :items="complaints" @row-clicked="showComplaintDetails"
          v-if="complaints.length > 0")
          template(slot="status" scope="thisComplaint")
            .complaint-status-wrapper(:class="`status-${statuses[thisComplaint.item.aasm_state].initials.toLowerCase()}`"
            ,:id="`status-${thisComplaint.item._id.$oid}`") {{ statuses[thisComplaint.item.aasm_state].initials }}
            complaint-popover(:thisComplaint="thisComplaint.item" ,:popoverTarget="`status-${thisComplaint.item._id.$oid}`")
          template(slot="token" scope="thisComplaint") {{ thisComplaint.item.ticket_info.booking_number }}

          template(slot="category" scope="thisComplaint") {{ thisComplaint.item.complaint_category.name }}

          template(slot="comment" scope="thisComplaint")
            div(:id="`comment-${thisComplaint.item._id.$oid}`") {{ thisComplaint.item.comment }}
            complaint-popover(:thisComplaint="thisComplaint.item"
              ,:popoverTarget="`comment-${thisComplaint.item._id.$oid}`")

          template(slot="age" scope="thisComplaint") {{ complaintAge(thisComplaint.item) }}

          template(slot="bus_operator" scope="thisComplaint") {{ busOperators(thisComplaint.item) }}

          template(slot="payment_method" scope="thisComplaint") {{ thisComplaint.item.ticket_info.payment_method }}

          template(slot="amount_requested" scope="thisComplaint")
            div(v-if="thisComplaint.item.reimbursement")
              span(v-if="thisComplaint.item.reimbursement.compensation_type === 'm'")
                template(v-if="['WebPay', 'Agencia', 'Fintoc', 'OneClick'].includes(thisComplaint.item.ticket_info.payment_method)")
                  | {{ thisComplaint.item.reimbursement.amount | currency('CLP $', 0, { thousandsSeparator: '.'}) }}
                template(v-else)
                  | {{ thisComplaint.item.reimbursement.amount | currency('USD $', 2, { thousandsSeparator: ',', decimalSeparator: '.' }) }}
              span(v-else) No monetario
            div(v-else) Aún no está cerrado

          template(slot="approved_at" scope="thisComplaint")
            div(v-if="thisComplaint.item.reimbursement")
              | {{ thisComplaint.item.approved_at | formatFullDate }}
            div(v-else) Aún no está cerrado

          template(slot="devolution_at" scope="thisComplaint")
            div(v-if="thisComplaint.item.reimbursement && thisComplaint.item.aasm_state === 'closed'")
              span(v-if="thisComplaint.item.reimbursement.compensation_type === 'm'")
                | {{ thisComplaint.item.reimbursement.devolution_at | formatFullDate }}
              span(v-else) No monetario
            div(v-else) Aún no está cerrado

          template(slot="statuses" scope="thisComplaint")
            .btn-group(role='group')
              button.btn.btn-sm(class="btn-outline-danger" type='button' title="Descontar a empresa" v-if="thisComplaint.item.reimbursement.discount_from_company")
                icon(name="dollar")
              button.btn.btn-sm(class="btn-outline-primary" type='button' title="No se descuenta a empresa" v-else)
                icon(name="dollar")
              button.btn.btn-sm(class="btn-success" type='button' title="Descargado en planilla de descuentos" v-if="thisComplaint.item.discounted")
                icon(name="check")
              button.btn.btn-sm(class="btn-outline-danger" type='button' title="Descargado en planilla de descuentos" v-else)
                icon(name="check")

          template(slot="edit_complaint" scope="thisComplaint")
            router-link(:to="{ name: 'show_complaint', params: { complaint_id: thisComplaint.item._id.$oid } }").show-link
        div(v-else)
          br
          p No hay reclamos por mostrar 🎉

        b-pagination(align="center" ,:total-rows="pagination.total" v-model="pagination.current"
          ,:per-page="pagination.per_page" ,@change="changePage" v-if="complaints.length > 0")
    b-modal(v-model="modalDate", :busy="true")
      b-form.form-horizontal
        b-row.justify-content-md-center
          b-col(md="6")
            b-form-group(label="Desde")
              date-picker(v-model="from" lang="es" format="dd/MM/yyyy" input-class="form-control")
          b-col(md="6")
            b-form-group(label="Hasta")
              date-picker(v-model="to" lang="es" format="dd/MM/yyyy" input-class="form-control")
        b-row.justify-content-md-center
          b-col(md="12")
            b-form-group(label="Filtrar por")
              b-form-radio-group(v-model="intervalType" :options="intervalOptions")
          b-col(md="12")
            b-form-group(label="Operador")
                selectize(v-model="busOperator")
                  option(v-for="operator in this.operatorsForSelect" :value="operator.id" :key="operator.id") {{ operator.name }}
          b-col(md="12")
            b-form-group(label="Excluir")
                selectize(v-model="excludedOperators" multiple)
                  option(v-for="operator in operators" :value="operator.id" :key="operator.id") {{ operator.name }}
          b-col(md="12")
            b-form-group(label="Categoría")
              selectize(v-model="complaintCategory" placeholder="Elige una categoría")
                option(v-for="key in Object.keys(categories)" :value="key" :key="key") {{ categories[key].description }}
        b-row.justify-content-md-center
          b-col(md="12")
            b-form-group(label="Total")
              b-form-input(:value="total | currency('$', 0, { thousandsSeparator: '.'})"
              class="form-control" type="text" readonly)
      div(slot="modal-footer")
        b-btn.btn-space(variant="secondary", @click="closeModal") Cancelar
        b-btn(variant="primary", @click="exportData") Descargar
    b-modal(v-model="modalReimbursement", :busy="true")
      b-form.form-horizontal
        b-row.justify-content-md-center
          b-col(md="6")
            b-form-group(label="Desde")
              date-picker(v-model="from" lang="es" format="dd/MM/yyyy" input-class="form-control")
          b-col(md="6")
            b-form-group(label="Hasta")
              date-picker(v-model="to" lang="es" format="dd/MM/yyyy" input-class="form-control")
        b-row.justify-content-md-center
          b-col(md="12")
            b-form-group(label="Monto máximo (USD)")
              b-form-input(v-model="maxAmount" class="form-control" type="number")
        b-row.justify-content-md-center
          b-col(md="12")
            b-form-group(label="Filtrar por")
              b-form-radio-group(v-model="intervalType" :options="intervalOptions")
          b-col(md="12")
            b-form-group(label="Operador")
                selectize(v-model="busOperator")
                  option(v-for="operator in this.operatorsForSelect" :value="operator.id" :key="operator.id") {{ operator.name }}
          b-col(md="12")
            b-form-group(label="Excluir")
                selectize(v-model="excludedOperators" multiple)
                  option(v-for="operator in operators" :value="operator.id" :key="operator.id") {{ operator.name }}
          b-col(md="12")
            b-form-group(label="Categoría")
              selectize(v-model="complaintCategory" placeholder="Elige una categoría")
                option(v-for="key in Object.keys(categories)" :value="key" :key="key") {{ categories[key].description }}
        b-row.justify-content-md-center
          b-col(md="12")
            b-form-group(label="Total")
              b-form-input(:value="total | currency('$', 2, { thousandsSeparator: ',', decimalSeparator: '.' })" class="form-control" type="text" readonly)
      div(slot="modal-footer")
        b-btn.btn-space(variant="secondary", @click="closeModal") Cancelar
        b-btn(variant="primary", @click="paypalReimburse") Reembolsar
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Selectize from 'vue2-selectize';
import store from '@/store';
import constants from '@/constants/Status.constants';
import kexaApi from '@/services/apiService';
import LastActivity from '@/components/layout/LastActivity';
import complaintPopover from '@/components/layout/PopoverDetail';
import financePerimeter from '@/perimeters/financePerimeter';
import dateService from '@/utils/dateService';

const parse = require('parse-link-header');

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

export default {
  name: 'finance',
  components: {
    LastActivity,
    complaintPopover,
    DatePicker,
    Selectize,
  },
  perimeters: [financePerimeter],
  data() {
    return {
      complaintFields: {
        number: {
          label: 'ID',
          sortable: true,
        },
        status: {
          label: 'Estado',
          sortable: true,
          tdClass: 'status-holder',
        },
        token: { label: 'Número de compra' },
        category: {
          label: 'Categoría',
          sortable: true,
        },
        age: { label: 'Edad' },
        bus_operator: { label: 'Empresa de bus' },
        amount_requested: { label: 'Monto reclamado' },
        payment_method: { label: 'Medio de pago' },
        approved_at: { label: 'Fecha de aprobación' },
        devolution_at: { label: 'Fecha de devolución' },
        statuses: { label: 'Descuentos' },
      },
      categories: [],
      statuses: constants.STATUSES,
      complaints: [],
      operators: [],
      pagination: {},
      filterText: '',
      intervalId: null,
      modalDate: false,
      modalReimbursement: false,
      resolved: false,
      from: null,
      to: null,
      busOperator: '',
      excludedOperators: [],
      complaintCategory: null,
      intervalType: 'approved_at',
      intervalOptions: [
        { text: 'Fecha aprobación', value: 'approved_at' },
        { text: 'Fecha ingreso', value: 'created_at' },
      ],
      maxAmount: 0,
      total: 0,
      action: null,
      showDialog: false,
    };
  },
  created() {
    this.fetchCategories();
    this.fetchComplaints(undefined, false);
    this.fetchOperators();
  },
  watch: {
    from() {
      this.updateTotals();
    },
    to() {
      this.updateTotals();
    },
    busOperator() {
      this.updateTotals();
    },
    complaintCategory() {
      this.updateTotals();
    },
    intervalType() {
      this.updateTotals();
    },
    excludedOperators() {
      this.updateTotals();
    },
  },
  methods: {
    busOperators(complaint) {
      const busOperators = complaint.ticket_info.bus_operators;

      if (busOperators.length > 1) {
        return String(busOperators).replace(',', ', ');
      }
      return String(busOperators);
    },
    complaintAge(complaint) {
      return dateService.complaintAge(complaint.created_at);
    },
    fetchCategories() {
      kexaApi.get_categories().then((res) => {
        this.categories = res.body.reduce((acc, item) => {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchComplaints(page) {
      const $this = this;
      kexaApi.finance(page, this.filterText, this.resolved)
        .then((data) => {
          $this.complaints = data.body;
          if (data.body.length === 0 && this.filterText !== '') {
            $this.$notify({
              group: 'finance',
              type: 'error',
              title: 'Error',
              text: 'No se encontraron resultados',
              duration: 2000,
            });
          }
          $this.setPagination(data);
        });
    },
    fetchOperators() {
      kexaApi.get_operators()
        .then((data) => {
          this.operators = data.body;
        });
    },
    setPagination(res) {
      const links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links')
        ? parse(res.headers.map.link[0])
        : null;
      const pagination = {
        current: parseInt(res.headers.map.page, 10),
        total: parseInt(res.headers.map.total, 10),
        per_page: parseInt(res.headers.map['per-page'], 10),
        ...links,
      };
      this.$set(this, 'pagination', pagination);
    },
    changePage(page) {
      this.fetchComplaints(page);
    },
    showComplaintDetails(complaint) {
      store.commit('selectComplaint', complaint);
      this.$router.push(`/complaints/${complaint._id.$oid}`);
    },
    search() {
      this.fetchComplaints(1);
    },
    refreshComplaints() {
      this.intervalId = setInterval(() => {
        this.fetchComplaints(undefined, false);
      }, 120000);
    },
    openModal(action) {
      this.modalDate = true;
      this.action = action;
    },
    paypalModal() {
      this.modalReimbursement = true;
      this.action = 'paypal';
    },
    paypalReimburse() {
      const $this = this;
      if (this.from === null || this.to === null || this.maxAmount <= 0) {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Error al ingresar los parámetros',
          duration: 2000,
        });
      } else {
        const from = dateService.getDate(this.from);
        const to = dateService.getDate(this.to);
        kexaApi.refundPaypal({
          from,
          to,
          max_amount: this.maxAmount,
          busOperator: this.busOperator,
          category: this.complaintCategory,
          interval: this.intervalType,
          excludedOperators: this.excludedOperators,
        }).then((res) => {
          $this.fetchComplaints(1);
          $this.closeModal();
          $this.$notify({
            group: 'finance',
            type: 'success',
            title: 'Reembolso finalizado',
            text: res.body,
            duration: 3000,
          });
        }).catch(() => {
          $this.$notify({
            group: 'finance',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error al realizar el reembolso',
            duration: 2000,
          });
        });
      }
    },
    exportAll() {
      kexaApi.downloadAll().then(() => {
        this.$notify({
          group: 'finance',
          type: 'success',
          title: 'Descargar Reclamos',
          text: 'Se enviará un mail junto con el archivo csv',
          duration: 5000,
        });
      });
    },
    exportData() {
      const $this = this;
      if (this.from === null || this.to === null) {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Debe ingresar fechas',
          duration: 2000,
        });
      } else {
        const from = dateService.getDate(this.from);
        const to = dateService.getDate(this.to);
        if (this.action === 'discount') {
          kexaApi.downloadDiscount(from, to).then((res) => {
            $this.handleDownload(res);
            $this.closeModal();
          });
        } else {
          const options = {
            from,
            to,
            busOperator: this.busOperator,
            category: this.complaintCategory,
            interval: this.intervalType,
            excludedOperators: this.excludedOperators,
          };
          kexaApi.downloadBice(options).then((res) => {
            $this.handleDownload(res);
            $this.closeModal();
          });
        }
      }
    },
    importBice() {
      document.getElementById('requestFile').click();
    },
    uploadFile() {
      const $this = this;
      const formData = new FormData();
      formData.append('file', document.getElementById('requestFile').files[0]);
      kexaApi.uploadBice(formData).then((res) => {
        $this.fetchComplaints(1);
        $this.$notify({
          group: 'finance',
          type: 'success',
          title: 'Carga finalizada',
          text: res.body,
          duration: 3000,
        });
      }).catch(() => {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Ocurrió un error al subir el archivo',
          duration: 3000,
        });
      });
    },
    handleDownload(res) {
      const blob = new Blob([res.body], { type: res.headers.get('content-type') });
      const filename = (res.headers.get('content-disposition') || '').split('filename=')[1];
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename.replace(/"/g, '');
      a.click();
    },
    closeModal() {
      this.from = null;
      this.to = null;
      this.action = null;
      this.maxAmount = 0;
      this.total = 0;
      this.modalDate = false;
      this.modalReimbursement = false;
      this.busOperator = '';
      this.complaintCategory = null;
      this.excludedOperators = [];
    },
    showResolved() {
      this.fetchComplaints(1);
    },
    updateTotals() {
      const $this = this;
      if (this.from !== null && this.to !== null) {
        const from = dateService.getDate(this.from);
        const to = dateService.getDate(this.to);
        const options = {
          from,
          to,
          action: this.action,
          busOperator: this.busOperator,
          category: this.complaintCategory,
          interval: this.intervalType,
          excludedOperators: this.excludedOperators,
        };
        kexaApi.getTotal(options)
          .then((res) => {
            console.log(res.body); // eslint-disable-line
            $this.total = res.body.total;
          }).catch(() => {
            $this.total = 0;
          });
      }
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  computed: {
    operatorsForSelect() {
      return [{ name: 'Todos los operadores', id: '' }].concat(this.operators);
    },
  },
  mounted() {
    this.refreshComplaints();
    this.refreshReloaAppStatus();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  @import '../assets/css/kexa-variables';

  .description-container {
    max-height: 74px;
    overflow-y: scroll;
  }
  .b-table {
    font: {
      size: 13px;
    }
    margin: {
      top: 12px;
    }
    tr {
      cursor: pointer;
    }
    td {
      padding: 0.65rem;
      &.status-holder {
        text: {
          align: center;
          transform: lowercase;
        }
      }
    }
  }
  [id^="comment-"] {
    cursor: pointer;
  }
  .tabs-container {
    border-radius: 0;
    .card-header {
      background: {
        color: #FFF;
      }
      .nav-item > .nav-link {
        color: #000;
        &:hover {
          color: #666;
        }
      }
    }
  }
  .filters-title {
    padding: {
      top: 6px;
      right: 12px;
    }
  }
  .btn-space {
    margin-right: 5px;
  }
  .download-btns {
    & .btn .fa-icon {
      vertical-align: middle;
      margin-right: 0.5rem;
    }
    & .btn .fa-icon:last-child {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Finance.vue